import React from "react";
import SidebarNav from "../../components/SidebarNav/SidebarNav";
import PrimaryNav from "../../components/PrimaryNav/PrimaryNav";
import menuItems from "../../helpers/menus/sidebarMenu.json";


const HelpAndSupportTemplate = ({ children, crumb, hideSidebar, overrideClasses }) => {

    const childrenArray = React.Children.toArray(children)
    const firstChild = childrenArray[0];
    const blueBackgroundElements = childrenArray.slice(1)
  
    return (
      <div>
        <PrimaryNav />
        {/* <Breadcrumbs crumbs={breadcrumbs} /> */}
        <main className="p-10-40">
          <div className={`${overrideClasses ? overrideClasses : "grid-row grid-gap padding-bottom-5"}`}>
            {!hideSidebar && <SidebarNav menuItems={menuItems} />}
            <div className={hideSidebar ? "" : "tablet:grid-col-8"}>
              { firstChild }
            </div>
          </div>
          { blueBackgroundElements.length > 0 && <div className="grid-row grid-gap padding-bottom-5">
            { blueBackgroundElements }
          </div>}
        </main>
      </div>
    );
  }
  export default HelpAndSupportTemplate
